import { Command } from "src/games/ProgramRobotGame/objects/Command";
import { Arrow } from "src/games/ProgramRobotGame/objects/Arrow";
export class CommandSlot extends Phaser.GameObjects.Zone {
    public index: number;
    public filled: boolean;
    public textObject: Phaser.GameObjects.Text;
    public arrow: Arrow;
    public image: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number, index: number) {
        super(scene, x, y, width, height);

        this.index = index;
        this.filled = false;
    }

}



// WEBPACK FOOTER //
// ./src/games/ProgramRobotGame/objects/CommandSlot.ts